import React from 'react';

const Confirmation = () => {

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', minHeight: '80vh', padding: '10px' }}>
                <div style={{ margin: 'auto', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <h3 style={{ color: "#14586f", textAlign: "center", fontSize: "1.875rem", marginBottom: "1rem", lineHeight: "1.2" }}>
                        Thank You For Your interest
                    </h3>

                    <h5 style={{ fontWeight: 'bold' }}> Now you are eligible to avail 20% off </h5>
                </div>
            </div>
        </>
    )
}

export default Confirmation;